export default __webpack_public_path__ + "static/media/grid16.9e2eaef9.png";